/**
 * Display labels for the Enrollio Forms template catalog (ENR-1474).
 * Mirrors the labels in enrollio-be src/forms/form-templates.ts; keep the
 * two in sync when the catalog changes.
 */
const FORM_TYPE_LABELS: Record<string, string> = {
  class_availability_lead_capture: 'Lead Capture',
  trial_inquiry: 'Trial Inquiry',
  contact_us: 'Contact Us',
  summer_camp_inquiry: 'Summer Camp Inquiry',
  birthday_party_inquiry: 'Birthday Party Inquiry',
  waitlist_interest: 'Waitlist Interest',
  fall_registration_interest: 'Fall Registration Interest',
  event_interest: 'Event Interest',
  create_your_own: 'Create Your Own',
};

export function formatFormTypeLabel(formType: string): string {
  return (
    FORM_TYPE_LABELS[formType] ??
    formType
      .split(/[-_]/g)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ')
  );
}
